import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { NgxPermissionsGuard } from 'ngx-permissions';
import { AgmCoreModule } from '@agm/core';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { NgxCarouselModule } from 'ngx-carousel';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { DivisionsConfigColorsComponent } from './divisions-config-colors/divisions-config-colors.component';
import { SharedModule } from '../../../../../core/modules/shared.module';
import { FuseWidgetModule } from '../../../../../core/components/widget/widget.module';
import { CourseYearService } from '../../../../services/cour-years/course-year.service';
import { IndexCardConfigurationComponent } from './index-card-configuration/index-card-configuration.component';
import { IndexCardConfigurationModule } from './index-card-configuration/index-card-configuration.module';
import { ReportConfigurationComponent } from './report-configuration/report-configuration.component';
import { ReportConfigurationService } from '../../../../services/report-configuration/report-configuration.service';


const routes = [
    {
        path: 'pages/management/divisionscolorconfig',
        component: DivisionsConfigColorsComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_MANAGEMENT_DIVISIONS',
                redirectTo: '/pages/errors/error-403'
            },
            mode : 'view'
        }
    },
    {
        path: 'pages/management/indexcardconfig',
        component: IndexCardConfigurationComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_MANAGEMENT_DIVISIONS',
                redirectTo: '/pages/errors/error-403'
            },
            mode : 'view'
        }
    },
    {
        path: 'pages/management/reportconfig',
        component: ReportConfigurationComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_MANAGEMENT_DIVISIONS',
                redirectTo: '/pages/errors/error-403'
            },
            mode : 'view'
        }
    }
];

@NgModule({
    declarations: [
        DivisionsConfigColorsComponent,
        ReportConfigurationComponent
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        IndexCardConfigurationModule,
        AgmCoreModule,
        AgmSnazzyInfoWindowModule,
        NgxCarouselModule,
        FuseWidgetModule,
        NgxChartsModule
    ],
    exports: [
    ],
    providers: [
        CourseYearService,
        ReportConfigurationService
    ],
    entryComponents: [
    ]
})

export class ConfigurationsModule {
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/configurations/configurations.module.ts